module.exports = __webpack_public_path__ + "media/icons/categories-d18b4529.svg";